import { Form, Input, message, Modal, Tree } from "antd";
import { Rule } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import { roleApi } from "api/role.api";
import React, { useEffect, useState } from "react";
import { adminRoutes } from "router";
import { ModalStatus } from "types/modal";
import { Permission, Role } from "types/role";
import { Staff } from "types/staff";

const rules: Rule[] = [{ required: true, message: "Bắt buộc" }];

interface ITreeData {
  title: string;
  key: string;
  children?: ITreeData[];
}

export const RoleModal = ({
  visible,
  status,
  role,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  status: ModalStatus;
  role: Partial<Role>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = Form.useForm<Staff>();
  const [loading, setLoading] = useState(false);
  const [treeData, setTreeData] = useState<ITreeData[]>([]);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  const [permissions, setPermissions] = useState<Permission[]>([]);

  useEffect(() => {
    if (status == "create" && visible) {
      form.resetFields();
    }
  }, [visible, status]);

  useEffect(() => {
    form.setFieldsValue({ ...role });
    generateSelectedKeys();
    return () => {};
  }, [role]);

  useEffect(() => {
    generateTreeData();
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    const res = await roleApi.getPermission();
    setPermissions(res.data);
  };

  const generateSelectedKeys = async () => {
    if (role.id) {
      const res = await roleApi.findOne(role.id);
      const permissions: Permission[] = res.data.permissions;

      setCheckedKeys(permissions.map((e) => e.path));
    }
  };

  const generateTreeData = () => {
    if (treeData.length) {
      return;
    }
    for (const route of adminRoutes) {
      const data: ITreeData = {
        title: route.title || "",
        key: route.path || "",
      };

      treeData.push(data);
      if (route.children) {
        data.children = [];
        for (const childRoute of route.children) {
          data.children.push({
            title: childRoute.title || "",
            key: route.path + "/" + childRoute.path || "",
          });
        }
      }
    }

    console.log("generateTreeData", treeData);

    setTreeData([...treeData]);
  };

  const createData = async (data: any) => {
    setLoading(true);
    try {
      const res = await roleApi.create(data);
      message.success("Tạo mới thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const updateData = async (data: any) => {
    setLoading(true);
    try {
      const res = await roleApi.update(role?.id || 0, data);
      message.success("Cập nhật thành công");
      onClose();
      onSubmitOk();
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const valid = await form.validateFields();
    const data = {
      role: form.getFieldsValue(),
      permissionIds: checkedKeys
        .map((e) => {
          const find = permissions.find((p) => p.path == e);
          return find?.id;
        })
        .filter((e) => e),
    };
    if (status == "create") {
      createData(data);
    } else {
      updateData(data);
    }
  };

  const onSelect = (selectedKeys: any, info: any) => {};

  const onCheck = (checkedKeys: any, info: any) => {
    setCheckedKeys(checkedKeys);
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={status == "create" ? "Tạo mới quyền" : "Cập nhật quyền"}
      style={{ top: 20 }}
      width={700}
      confirmLoading={loading}
      onOk={() => {
        handleSubmit();
      }}
    >
      <Form layout="vertical" form={form}>
        <Form.Item label="Tên quyền" name="name" rules={rules}>
          <Input placeholder="" />
        </Form.Item>

        <Form.Item label="Mô tả" name="description">
          <TextArea rows={3} />
        </Form.Item>

        <Tree
          checkable
          onSelect={onSelect}
          onCheck={onCheck}
          treeData={treeData}
          checkedKeys={checkedKeys}
        ></Tree>
      </Form>
    </Modal>)
  );
};
